export const licenseApiBaseUrl = process.env.REACT_APP_API_BASE_URL!;
